import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'export-dropdown',
  templateUrl: 'export-dropdown.component.html',
  styleUrls: ['export-dropdown.component.scss'],
})
export class ExportDropdownComponent {
  isOpened: boolean = false;

  @Input() dropup: boolean = true;
  @Input() actionsList: Array<any>;

  @Output() actionSelected = new EventEmitter();

  onSelectedChange($event: any) {
    this.actionSelected.emit($event);
  }

  onDropdownChange(isOpened: boolean) {
    this.isOpened = isOpened;
  }
}
